// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class PasswordContent implements flatbuffers.IUnpackableObject<PasswordContentT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): PasswordContent {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsPasswordContent(
    bb: flatbuffers.ByteBuffer,
    obj?: PasswordContent,
  ): PasswordContent {
    return (obj || new PasswordContent()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsPasswordContent(
    bb: flatbuffers.ByteBuffer,
    obj?: PasswordContent,
  ): PasswordContent {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new PasswordContent()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  username(): string;
  username(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  username(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  password(): string;
  password(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  password(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startPasswordContent(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addUsername(builder: flatbuffers.Builder, usernameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, usernameOffset, 0);
  }

  static addPassword(builder: flatbuffers.Builder, passwordOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, passwordOffset, 0);
  }

  static endPasswordContent(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // username
    builder.requiredField(offset, 6); // password
    return offset;
  }

  static createPasswordContent(
    builder: flatbuffers.Builder,
    usernameOffset: flatbuffers.Offset,
    passwordOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    PasswordContent.startPasswordContent(builder);
    PasswordContent.addUsername(builder, usernameOffset);
    PasswordContent.addPassword(builder, passwordOffset);
    return PasswordContent.endPasswordContent(builder);
  }

  unpack(): PasswordContentT {
    return new PasswordContentT(this.username(), this.password());
  }

  unpackTo(_o: PasswordContentT): void {
    _o.username = this.username();
    _o.password = this.password();
  }

  unpackFields(...fields: string[]): PasswordContentT {
    const t = new PasswordContentT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("username")) {
      t.username = this.username();
    }
    if (fieldSet.has("password")) {
      t.password = this.password();
    }
    return t;
  }
}

export class PasswordContentT implements flatbuffers.IGeneratedObject {
  constructor(
    public username: string | Uint8Array | null = null,
    public password: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.username === null || this.username === undefined) {
      throw new Error('Required field "username" is not set');
    }
    if (this.password === null || this.password === undefined) {
      throw new Error('Required field "password" is not set');
    }
    const username = this.username !== null ? builder.createString(this.username!) : 0;
    const password = this.password !== null ? builder.createString(this.password!) : 0;

    return PasswordContent.createPasswordContent(builder, username, password);
  }

  clone(): PasswordContentT {
    const obj = new PasswordContentT();
    obj.username = this.username;
    obj.password = this.password;
    return obj;
  }

  equals(other: PasswordContentT): boolean {
    if (this.username !== other.username) return false;
    if (this.password !== other.password) return false;
    return true;
  }
}

export function verifyPasswordContent(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "username");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "password");
  } finally {
    verifier.popDepth();
  }
}
